<template>
    <div class="mc-content-operation-bar">
        <div class="left">
            <slot name="left"></slot>
        </div>
        <div class="center">
            <slot name="center"></slot>
        </div>
        <div class="right">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "mc-operate-bar"
    }
</script>

<style lang="less" scoped>
    .mc-content-operation-bar {
        width: 100%;
        height: 80px;
        padding: 20px;
        display: inline-flex;
    }
</style>